// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — add-form.classic.js, новая — add-form.cp.js
import { isCp } from 'libs/design';
import * as classic from './add-form.classic';
import * as cp from './add-form.cp';

export const AddForm = isCp ? cp.AddForm : classic.AddForm;
